import BaseService, { ServiceInterface } from 'services/BaseService';

export default class MenuPositionService extends BaseService implements ServiceInterface {
	_type = 'menuPosition';
	_typeKey = 'type';
}
